import {
  createApiRef,
  DiscoveryApi,
  FetchApi,
} from '@backstage/frontend-plugin-api';
import type { StatusSnapshot } from './types';

export interface ExternalDownDetectorApi {
  getStatus(): Promise<StatusSnapshot>;
}

export const externalDownDetectorApiRef =
  createApiRef<ExternalDownDetectorApi>().with({
    id: 'plugin.external-down-detector',
    pluginId: 'external-down-detector',
  });

export class ExternalDownDetectorApiClient implements ExternalDownDetectorApi {
  constructor(
    private readonly discoveryApi: DiscoveryApi,
    private readonly fetchApi: FetchApi,
  ) {}

  async getStatus(): Promise<StatusSnapshot> {
    const baseUrl = await this.discoveryApi.getBaseUrl(
      'external-down-detector',
    );
    const response = await this.fetchApi.fetch(`${baseUrl}/status`);
    if (!response.ok) {
      const body = (await response.json().catch(() => ({}))) as {
        error?: string;
      };
      throw new Error(
        body.error ?? `Failed to fetch status: ${response.status}`,
      );
    }
    return response.json();
  }
}
